import React,{useRef, useState, useEffect} from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, Badge, InputGroup, Spinner  } from "react-bootstrap";
import {setUrlParam } from "../utils/functions";
import Select from "react-select";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import Header from "../layouts/Header";
import parse from 'html-react-parser';
import {projectPhaseColors} from "../data/ProjectStatusColor";
import Country from "../classes/Country";
import atlasApi from "../utils/atlasapi";
import authApi from "../utils/authApi";
import Loader from "../components/Loader";
import Filter from "../components/Filter";
import SearchProperty from "../components/SearchProperty";
import UserMenu		from "../components/UserMenu";

//import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
 
//mapboxgl.accessToken = 'pk.eyJ1IjoiZXNwZW52aW5kciIsImEiOiJjbGZpOXoyamIyYW1wM3FuMXBidjlvcXl5In0.XDmLF8QmTyYR-PiDcnDFGQ';


export default function Properties() {

	const [pageTitle,setPageTitle]		= useState('List of Properties');
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	
	document.body.className="properties";
	
	var countrySel		= params.get("country") ? params.get("country").split(",")	: [];
	var lastCall;
	/*
	options of the sort by select box
	*/
	const ownersSortOptions = [
		{label:"Name", value:"name"},
		{label:"Email", value:"email"}
	];
	
	const [orderBy, setOrder]					= useState('');
	const [needle, setNeedle]					= useState('');
	const [data,setProperties]						= useState([]);
	const [user,setUser]						= useState({});
	const [showFilters,setShowFilters]			= useState(false);
	const [pending,setPending]					= useState(false); //status variable set when all data is loaded
	const [filterCountry, setFilterCountry]			= useState(new Set(countrySel));
	
	
	
	const countryComp = React.createRef();
	
	
	const getData = ()=>{ 
		

		Promise.all([atlasApi.getToken()])
		.then((res) => {
			
			const dataRequests = [
				authApi.getUser()

			];
			return Promise.all(dataRequests);
		}).then((res)=>{
			var responses = res.map((response) => {
				if(response.json)
					return response.json();
				return response;
			});
			return Promise.all(responses);
		}).then(function(responses) {
			var user = responses[0];
			
			setUser(user);
			
//			myJson.map((item)=>{
//				//cleanup some newline characters,etc from the names
//				item.fullName = item.fullName.trim();
//				if(item.email)
//					item.email = item.email.trim();
//				//
//				//... other validation and cleanuup tasks can be added
//			})

			if(!filterCountry.length && user.settings.ownerFilters && user.settings.ownerFilters.country.length && countryComp.current){
				selectFilter("country", user.settings.ownerFilters.country, setFilterCountry)
				countryComp.current.setValue(user.settings.ownerFilters.country);
			}
			document.title = process.env.REACT_APP_DOC_TITLE;
			setPending(false);
		});

		
		
	};

	
	var selectFilter = (filter, opts, callback) => {
		
		//add filter to url
		setUrlParam(filter, opts.map(obj => obj.value).join(","));
		
		//we use a Set so to avoid repeat options
		callback(new Set(opts.map(obj => obj.value)));
		
		//update user settings
		saveFilter(filter, opts);
	};
	

	useEffect(()=>{
		getData();
	},[])		

	var search = (a) => {
		
		if(a.target.value.length>2 || !a.target.value.length) {
			setUrlParam("search", a.target.value);
			setNeedle(a.target.value)
		}
	};
	function highlight(str, group1, group2) {
		return "<span class=bg-warning>"+str+"</span>";
	}
	const saveFilter = (filter, value)=>{
		
		if(user && user.userDetails && user.settings){
			if(!user.settings.ownerFilters)
				user.settings.ownerFilters = {};
			user.settings.ownerFilters[filter] = value;
			user.email = user.userDetails;

			atlasApi.updateSettings(user);
		}
		
	}
	const renderProperties = ()=> {

		if(data && data.length>0 ) {
			



			return data.map((item, index)=>{


				/* lets highlight the text users search, for usability */
				
				let phone = '';
				let street = '';
				let email = '';
				let projects = '';


				if(item.projects && item.projects.length)
					projects = item.projects.map((a) => {return (<Link to={"/pages/project/" + a.id}><Badge className="ms-3" bg="primary text-white">{parse(a.name.replace(new RegExp(needle, "i"), highlight))}</Badge></Link>)})
				



				if(
					(!filterCountry.size || filterCountry.has(item.country))
				){
					return (

						<Card key={index} className="card card-owner m-2">
							<Card.Header>
								<h6 className="card-title">
									{parse(item.id.replace(new RegExp(needle, "i"), highlight))}
									{projects}
								</h6>
							</Card.Header>
							<Card.Body>
								<Row>
									<Col xs="12" className="fw-bold">
										<h5>Owner(s)</h5>
									</Col>
								</Row>
								<Row>

									<Col xs="4" className="fw-bold">
										<div>Name</div>
									</Col>
									<Col xs="2" className="fw-bold">
										<div>Email</div>
									</Col>
									<Col xs="2" className="fw-bold">
										<div>Phone</div>
									</Col>
									<Col xs="4" className="fw-bold">
										<div>Address</div>
									</Col>
								</Row>
								{item.landowners.map((owner, j)=>{
									
									return (
										<Row key={j}>
									
											<Col xs="4">
												<div>{owner.fullName ? parse(owner.fullName.replace(new RegExp(needle, "i"), highlight)) : ' '} &nbsp;</div>
											</Col>
											<Col xs="2">
												<div>{owner.email ? parse(owner.email.replace(new RegExp(needle, "i"), highlight)) : ' '} &nbsp;</div>
											</Col>
											<Col xs="2">
												<div>{owner.phone ? parse(owner.phone.replace(new RegExp(needle, "i"), highlight)) : ' '} &nbsp;</div>
											</Col>
											<Col xs="4">
												<div>
													{owner.street ? parse(owner.street.replace(new RegExp(needle, "i"), highlight)) : ' '}
													{owner.zipcode ? ', '+parse(owner.zipcode.replace(new RegExp(needle, "i"), highlight)) : ' '}
													{owner.city ? ', '+parse(owner.city.replace(new RegExp(needle, "i"), highlight)) : ' '} 
													&nbsp;
												</div>
											</Col>
										</Row>
									)
									
								})
								
								}
							</Card.Body>
						</Card>
					)
				}
			});
		}
	}

	return (
		<React.Fragment>
			<div className="header">
			
				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>
				
				
				<div className="middle">

					<Link to="/" className="header-logo">Energy Atlas</Link>

					
				</div>
				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/allod_atlas_logo.png" alt="Allod"/>
				</div>
				<div className="options">
						{user.userId && <UserMenu user={user} onUpdateUser={setUser} />}
						
				</div>
			</div>
			<div className="body dashboard2">
				<Sidebar />
				<div className="main properties p-4 p-lg-5">
					<Row>
						<Col xl>

							<Row className="g-3 pb-4">

								<Col xs="6">

									<SearchProperty searchHandler={(data, query)=>{setProperties(data); setNeedle(query)}} onSearchPending={(pending)=>{setPending(pending)}} keepResults />
								</Col>


								<Col xs="1" className="text-start pt-0 filter-wrp">

									<i role="button" className="ri-equalizer-line" onClick={(e)=>{setShowFilters(!showFilters); e.stopPropagation();}}></i>


									<Card onClick={(e)=>{e.stopPropagation();}} className={"projects-filter-panel shadow-sm "+(showFilters ? "d-block opacity-100" : "opacity-0")}>
										<Card.Body>
											<div className="g-3 pb-4">
												<div><b>Countries</b></div>
												<Filter ref={countryComp} options={Country.options} defaultValue={countrySel.map((a)=>{return {value:a, label:a};})} onChange={(a)=>{selectFilter("country", a, setFilterCountry)}} placeholder="All" isSearchable={false} isMulti />
											</div>

										</Card.Body>
									</Card>


								</Col>
								<Col xs="5" className="text-end pt-2"></Col>
								<Col xs="12">

									{
										Array.from(filterCountry).map((a, idx)=>{
											return (<span key={idx} className="filter-text d-inline-block p-1 px-2 my-1 me-4 rounded  border border-secondary-subtle bg-secondary-subtle">{a} <i role="button" onClick={()=>{countryComp.current.deSelect(a)}} className="ri-close-line"></i></span>)
										})

									}


								</Col>
							</Row>		

							<Row className="g-3">
							{pending ? <><div className="search-placeholder"><Spinner animation="border" variant="success" size="xl" /></div></> : renderProperties()}

							</Row>
						</Col>
					</Row>

				</div>


			</div>
			
			
		</React.Fragment>
	);
}
